import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AppStateProvider } from './RetailerFitGuide_StateContext.jsx';
import { RetailerFitGuide_Overview } from './RetailerFitGuide_Overview.jsx';
import { RetailerFitGuide_Header } from './RetailerFitGuide_Header.jsx';
import { RetailerFitGuide_Footer } from './RetailerFitGuide_Footer.jsx';
import { HashRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { RetailerFitGuide_ProductList } from './RetailerFitGuide_ProductList.jsx';
import RetailerFitGuide_PDP from './Newfit/RetailerFitGuide_PDP.jsx';
import RetailerFitGuide_Refit from './Refit/RetailerFitGuide_Refit.jsx';
const RetailerFitGuide = () => {
  const RetailerFitGuide_Layout_Memo = React.memo(() => {
    return (
      <>
        <RetailerFitGuide_Header />
        <div className="layout__content w-100">
          <div className={`retailerFitGuide_ContentWrapper `}>
            <main>
              <Outlet />
            </main>
          </div>
        </div>
        <RetailerFitGuide_Footer />
      </>
    );
  });

  const Layout = () => {
    return (
      <div className={`retailerFitGuide ${useLocation().pathname === '/' ? 'showBackgroundColor' : ''}`}>
        <RetailerFitGuide_Layout_Memo />
      </div>
    );
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<RetailerFitGuide_Overview />} />
          <Route path="refit" element={<RetailerFitGuide_Refit />} />
          <Route path="roofrack" element={<RetailerFitGuide_PDP />} />
          <Route path="productlist" element={<RetailerFitGuide_ProductList />} />
        </Route>
      </Routes>
    </Router>
  );
};
const root = createRoot(document.getElementById('REACT_retailerFitGuide'));
root.render(
  <AppStateProvider>
    <Sentry.ErrorBoundary>
      <RetailerFitGuide />
    </Sentry.ErrorBoundary>
  </AppStateProvider>
);
